import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';
import './image-gallery.css';

const Slideshow = ({ images }) => {
  // Convert images to the format required by react-image-gallery
  const galleryImages = images.map((img) => ({
    original: img.imageUrl,
    thumbnail: img.imageUrl,
    description: img.comment,
    originalWidth: img?.originalWidth,
    originalHeight: img?.originalHeight,
  }));

  const [isHovered, setIsHovered] = useState(false);
  let timer = null;
  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseMove = () => {
    setIsHovered(true);
    clearTimeout(timer);
    timer = setTimeout(() => {
      setIsHovered(false);
    }, 2000);
  };

  useEffect(() => {
    const icons = document.querySelectorAll('.image-gallery-icon');
    icons.forEach((icon) => {
      icon.style.transition = 'opacity 0.3s ease-out';
      icon.style.opacity = isHovered ? '1' : '0';
    });
  }, [isHovered]);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={() => setIsHovered(false)}
    >
      <ImageGallery
        items={galleryImages}
        showThumbnails={false}
        autoPlay={true}
        slideDuration={1000}
        slideInterval={5000}
        showNav={false}
        infinite={true}
        showBullets={true}
      />
    </div>
  );
};

// PropTypes for Slideshow
Slideshow.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default Slideshow;
